<template>
  <div id="results">
    <div v-if="$root.fittings.length">
      <div
        v-if="recommendedSize !== ''"
        class="recommended-size"
      >
        {{ $root.type }} SIZE: {{ recommendedSize }}
      </div>


      <p>
        Below are products recommended just for you!
      </p>

      <div class="ff-logo">
        <div>
          Powered by
        </div>
        <img src="../img/ff-logo.svg">
      </div>

      <!-- <div class="confidence-container">
        <div class="confidence-table">
          <div class="flex">
            <div style="width: 115px;">
              VERY HIGH -
            </div>
            <div>
              Above 90% fit confidence
            </div>
          </div>
          <div class="flex">
            <div style="width: 115px;">
              HIGH -
            </div>
            <div>
              70% - 89.9% fit confidence
            </div>
          </div>
        </div>
      </div> -->

      <template>
        <result
          v-for="product in $root.fittings"
          :key="product.shopify_id"
          :product="product"
        />
      </template>
    </div>
    <p v-if="$root.fittings && !$root.fittings.length">
      {{ no_fittings_message }}
      <br>
      No products match your search. We recommend ordering your typical swimsuit size. For a personalized fit recommendation please reach out to us at hello@kortnijeane.com.
    </p>
    <p v-if="!$root.fittings">
      Loading...
    </p>
  </div>
</template>

<script>
  import result from "./result.vue";

  import save_size from  '../functions/save_size';

  export default {
    components: {
      result,
    },
    computed: {
      no_fittings_message() {
        if (this.$root.category === 'baby_girl') {
          return 'Baby sizes offered are 3m, 6m and 9m. If no search results populate for your measurements we recommend trying the Mini Ladies category.';
        } else if (this.$root.category === 'baby_boy') {
          return 'Baby sizes offered are 3m, 6m and 9m. If no search results populate for your measurements we recommend trying the Mini Men\'s category.';
        } else if (this.$root.category === 'mini_lady') {
          return 'Mini Ladies sizes offered are 12-18m, 18-24m, 2/3Y, 4/5Y, 6/7Y and 8/9Y. If no search results populate for your measurements we recommend trying the Youth Ladies or Baby categories.';
        } else if (this.$root.category === 'mini_men') {
          return 'Mini Mens sizes offered are 12-18m, 18-24m, 2/3Y, 4/5Y, 6/7Y and 8/9Y. If no search results populate for your measurements we recommend trying the Youth Mens or Baby categories.';
        } else if (this.$root.category === 'youth_lady') {
          return 'Youth Ladies sizes offered are 10/11Y and 12/13Y. If no search results populate for your measurements we recommend trying the Women’s or Mini Ladies categories.';
        } else if (this.$root.category === 'youth_men') {
          return 'Youth Mens sizes offered are 10/11Y and 12/13Y.  If no search results populate for your measurements we recommend trying the Mens or Mini Mens categories.';
        } else if (this.$root.category === 'men') {
          return 'Mens sizes offered are S, M, L, XL, XXL, 28, 30, 32, 34, and 36.';
        } else if (this.$root.category === 'women') {
          return 'Womens sizes offered are XS, S, M, L, XL, XXL.';
        }
      },
      recommendedSize() {
        if (!this.$root.fittings.length) {
          return '';
        }

        const sizeTable = {};

        this.$root.fittings.forEach((fitting) => {
          if (fitting.true_size in sizeTable) {
            sizeTable[fitting.true_size] += 1;
          } else {
            sizeTable[fitting.true_size] = 1;
          }
        });

        let largest = '';
        let largest_key = '';
        for (const key in sizeTable) {
          if (sizeTable[key] > largest) {
            largest = sizeTable[key];
            largest_key = key;
          }
        }

        return largest_key;
      },
    },
  }
</script>

<style lang="less" scoped>
.kortni-jeane-fitting {
  #results {
    vertical-align: top;
    margin-top: 55px;
  }
  .confidence-container {
    max-width: 1024px;
    margin: 0 auto;
    text-align: left;
  }
  .confidence-table {
    display: inline-block;
    padding: 5px 8px;
    text-align: left;
    border: 1px solid grey;
  }
  .flex {
    display: flex;
  }
  .ff-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;

    span {
      line-height: 0px;
    }

    img {
      margin-left: 5px !important;
      height: 27px;
    }
  }
  .recommended-size {
    font-size: 30px !important;
    font-weight: bold !important;
    margin: 20px 0 20px !important;
    padding-top: 20px !important;
    text-transform: uppercase !important;
  }
}
</style>
